import {ListModel} from '@shared/models/list.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {DossierModel} from './dossier.model';


export class DossierList extends ListModel<DossierModel> {

	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			
			// TODO
			// da sostituire con una .map()
			model.items.forEach(dossier => this.items.push(new DossierModel(dossier)));
		}
	}
}
